'use client';

import HeroHead from './containers/herohead.server';

import ClientSideHeader from './components/Header.client';
import { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import Head from 'next/head';

const Home = () => {
  useEffect(() => {
    // Selecciona el marcador de posición y coloca el Header.client.jsx allí
    const placeholder = document.getElementById('client-header-placeholder');
    if (placeholder) {
      // Usamos hydrateRoot en lugar de hydrate
      const root = ReactDOM.hydrateRoot(placeholder, <ClientSideHeader />);
    }
  }, []);
  return (
    <>
      <Head>
        <title>dravvt - Immerse in the intersection of art and technology.</title>
        <meta name="description" content="Welcome to my main page, where technology and art collide, exploring innovation and creativity in these dynamic fields." />
        <meta name="author" content="dravvt" />
        
        {/* Meta para redes sociales */}
        <meta property="og:title" content="dravvt - Immerse in the intersection of art and technology." />
        <meta property="og:description" content="Welcome to my main page, where technology and art collide, exploring innovation and creativity in these dynamic fields." />
        <meta property="og:image" content="https://storage.googleapis.com/drago-imagenes-bucket/DravvtLogo2025.png" />
        <meta property="og:url" content="https://dravvt.com" />
        
        {/* Meta para Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="dravvt - Immerse in the intersection of art and technology." />
        <meta name="twitter:description" content="Welcome to my main page, where technology and art collide, exploring innovation and creativity in these dynamic fields." />
        <meta name="twitter:image" content="https://storage.googleapis.com/drago-imagenes-bucket/DravvtLogo2025.png" />
        <meta name="twitter:url" content="https://dravvt.com" />
      </Head>
      
      {/* Contenido de la página */}
      <div className="App">
        <div className="main-content">
          {/* Suponiendo que HeroHead es otro componente */}
          <HeroHead />
        </div>
      </div>
    </>
  );
};

export default Home;
